import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';
import {
	GetBannersV2,
	GetBannersV2Request,
	GetBannersV2Response,
} from 'domain/usecases/private/home/banners-v2';

export class RemoteGetBannersV2 implements GetBannersV2 {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetBannersV2Response>,
	) {}

	async post({signal, ...params}: GetBannersV2Request): Promise<GetBannersV2Response> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'post',
			body: params,
			signal,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
